var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 6.25H62.5C59.0625 6.25 56.25 9.0625 56.25 12.5C56.25 15.9375 59.0625 18.75 62.5 18.75H87.5C90.9375 18.75 93.75 15.9375 93.75 12.5C93.75 9.0625 90.9375 6.25 87.5 6.25ZM75 87.5C78.4375 87.5 81.25 84.6875 81.25 81.25V56.25C81.25 52.8125 78.4375 50 75 50C71.5625 50 68.75 52.8125 68.75 56.25V81.25C68.75 84.6875 71.5625 87.5 75 87.5ZM118.938 46.1875L123.625 41.5C126 39.125 126.063 35.1875 123.625 32.75L123.563 32.6875C121.125 30.25 117.25 30.3125 114.813 32.6875L110.125 37.375C100.438 29.625 88.25 25 75 25C45 25 19.5 49.75 18.75 79.75C17.9375 111.5 43.375 137.5 75 137.5C106.125 137.5 131.25 112.312 131.25 81.25C131.25 68 126.625 55.8125 118.938 46.1875ZM75 125C50.8125 125 31.25 105.438 31.25 81.25C31.25 57.0625 50.8125 37.5 75 37.5C99.1875 37.5 118.75 57.0625 118.75 81.25C118.75 105.438 99.1875 125 75 125Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.69977f0b.svg";
export { ForwardRef as ReactComponent };